import { useState, useCallback } from 'react';
import { p251Api } from '../../../services/p251Api';

export function useP251Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of P251 IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await p251Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fp610_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
